// Module
var code = "<user-avatar allowed-files=\"'image/x-png,image/jpeg'\" bringoz-upload=\"$ctrl.onUpload.bind($ctrl)\" url=\"$ctrl.user.pictureUrl\" user=\"$ctrl.user\" is-large=\"$ctrl.isLarge\"> </user-avatar> ";
// Exports
export default code;